
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flower",
      function () {
        return require("private-next-pages/flower.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flower"])
      });
    }
  